import { render, staticRenderFns } from "./BasicEducationTimeItem.vue?vue&type=template&id=7e258ea9&"
import script from "./BasicEducationTimeItem.vue?vue&type=script&lang=js&"
export * from "./BasicEducationTimeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports